import React from 'react';
import { ConnectedRouter, routerMiddleware, connectRouter } from 'connected-react-router';

/**
 * Creates and installs the Connected History Router
 */
export default {
  id: 'molten.RouterInit',
  sort: -30,
  createMiddleware: molten => {
    return routerMiddleware(molten.get('history'));
  },
  createReducers: molten => {
    return {
      router: connectRouter(molten.get('history'))
    };
  },
  createProvider: (molten, ...children) => {
    // eslint-disable-next-line react/destructuring-assignment
    return /*#__PURE__*/React.createElement(ConnectedRouter, {
      history: molten.get('history')
    }, ...children);
  }
};